export const FETCH_GRACE_POLICY_REQUEST = "FETCH_GRACE_POLICY_REQUEST";
export const FETCH_GRACE_POLICY_SUCCESS = "FETCH_GRACE_POLICY_SUCCESS";
export const FETCH_GRACE_POLICY_FAILURE = "FETCH_GRACE_POLICY_FAILURE";

export const SAVE_GRACE_POLICY_REQUEST = "SAVE_GRACE_POLICY_REQUEST";
export const SAVE_GRACE_POLICY_SUCCESS = "SAVE_GRACE_POLICY_SUCCESS";
export const SAVE_GRACE_POLICY_FAILURE = "SAVE_GRACE_POLICY_FAILURE";

export const FETCH_LEAVE_POLICY_REQUEST = "FETCH_LEAVE_POLICY_REQUEST";
export const FETCH_LEAVE_POLICY_SUCCESS = "FETCH_LEAVE_POLICY_SUCCESS";
export const FETCH_LEAVE_POLICY_FAILURE = "FETCH_LEAVE_POLICY_FAILURE";

export const SAVE_LEAVE_POLICY_REQUEST = "SAVE_LEAVE_POLICY_REQUEST";
export const SAVE_LEAVE_POLICY_SUCCESS = "SAVE_LEAVE_POLICY_SUCCESS";
export const SAVE_LEAVE_POLICY_FAILURE = "SAVE_LEAVE_POLICY_FAILURE";
